import { utilsModule } from "../utils-module";
import { react2angular } from 'react2angular';
import { UserExchangeContainer } from "../reactComponents/UserExchangeDialog/container/UserExchangeContainer";
import '../../../lang/i18n/i18n';

utilsModule.component('userExchangeDialog', react2angular(UserExchangeContainer, ['userPhotoContainerUrl','doLogout','doLogin','onCancel']));